import { stateful } from '@adornis/functional-lit/stateful.js';
import { html } from 'lit';
import { AccountingImportSection } from './dashboard-sections/AccountingImportSection.js';
import { ImportExportLocksSection } from './dashboard-sections/ImportExportLocksSection.js';
import { JobQueuesSection } from './dashboard-sections/JobQueuesSection.js';
import { MicrosoftErrorsSection } from './dashboard-sections/MicrosoftErrorsSection.js';
import { SystemStatsSection } from './dashboard-sections/SystemInformationSection.js';

/**
 * Rows of cards that wrap instead of a fixed grid: each card asks for a width it reads well at (`basis-*`) and the
 * wider partner takes the rest (`grow-2`), so phones stack them and wide screens pair them.
 */
export const AdminDashboard = stateful(
  () => html`
    <div class="card-container">
      <div class="flex flex-wrap gap-2 md:gap-4">
        <div class="min-w-0 grow-2 basis-xl">${SystemStatsSection()}</div>
        <div class="min-w-0 grow basis-80">${ImportExportLocksSection()}</div>
      </div>
      ${JobQueuesSection()}
      <div class="flex flex-wrap gap-2 md:gap-4">
        <div class="min-w-0 grow-2 basis-xl">${AccountingImportSection()}</div>
        <div class="min-w-0 grow basis-80">${MicrosoftErrorsSection()}</div>
      </div>
    </div>
  `,
);
